import { Button } from "@/shared/ui/kit/button";
import { useBoard } from "@/features/board/use-board";
import { Link, useLocation } from "react-router";
import { ROUTES } from "@/shared/model/routes";
import { getDeptPages, ALL_DEPT_PAGES } from "@/features/departments/dept-config";

const ROLE_LABELS: Record<string, string> = {
  ADMIN: "Администратор",
  OBSERVER: "Наблюдатель",
  EXECUTOR: "Исполнитель",
  MANAGER: "Менеджер",
};

const ROLE_COLORS: Record<string, string> = {
  ADMIN: "bg-red-100 text-red-700",
  OBSERVER: "bg-blue-100 text-blue-700",
  EXECUTOR: "bg-green-100 text-green-700",
  MANAGER: "bg-purple-100 text-purple-700",
};

export function AppHeader() {
  const { currentUser } = useBoard();
  const { pathname } = useLocation();

  const deptCode = currentUser?.department?.code ?? null;
  const deptPages = currentUser?.role === "ADMIN"
    ? ALL_DEPT_PAGES
    : getDeptPages(deptCode);

  const navLinks = [
    { to: ROUTES.BOARD, label: "Журнал" },
    ...deptPages.map((p) => ({ to: p.path, label: p.label })),
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <>
      {/* Хедер */}
      <div className="w-full min-h-[30px] border-b flex items-center sticky top-0 bg-white z-50">
        <div className="container flex mx-auto py-2 px-4 items-center gap-4">
          <div className="flex items-center font-bold text-2xl">
            EES <span className="text-green-600 font-normal">&nbsp;/СИТиАС</span>
          </div>

          {/* Навигация — только на десктопе */}
          <nav className="hidden sm:flex gap-1 ml-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                  pathname === link.to
                    ? "bg-gray-900 text-white"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            {currentUser && (
              <>
                <span className="text-sm text-gray-600 hidden sm:block">
                  {currentUser.fullName}
                </span>
                <span className={`text-xs px-2 py-1 rounded-full font-medium hidden sm:inline ${ROLE_COLORS[currentUser.role] ?? "bg-gray-100 text-gray-700"}`}>
                  {ROLE_LABELS[currentUser.role] ?? currentUser.role}
                </span>
                {currentUser.role === "ADMIN" && (
                  <Link to="/admin" className="hidden sm:block">
                    <Button variant="outline" size="sm">Пользователи</Button>
                  </Link>
                )}
              </>
            )}
            <Button onClick={handleLogout}>Выйти</Button>
          </div>
        </div>
      </div>

      {/* Нижняя навигация — только на мобильном */}
      <nav className="sm:hidden fixed bottom-0 left-0 right-0 bg-white border-t z-50 flex h-14">
        {navLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`flex-1 flex flex-col items-center justify-center text-xs font-medium transition-colors ${
              pathname === link.to ? "text-gray-900" : "text-gray-400"
            }`}
          >
            <span className={`w-6 h-1 rounded-full mb-1 ${pathname === link.to ? "bg-gray-900" : "bg-transparent"}`} />
            {link.label}
          </Link>
        ))}
      </nav>
    </>
  );
}
